export const projectCopyText = {
  title: "Copy project between accounts",
  intro: "Copy project data, files, and history into another account. Pause source edits and uploads before starting the copy. Keep them paused until the copy finishes.",
  sourceAccount: "Source account",
  source: "Source project",
  destinationAccount: "Destination account",
  choose: "Select an option",
  accountSearch: "Search by email or account number",
  noAccounts: "No matching accounts",
  preview: "Preview copy",
  previewing: "Preparing preview…",
  previewFailed: "No recoverable preview was received. Review the error and explicitly request a new preview.",
  differentAccounts: "Select different source and destination accounts.",
  fullHistory: "The copy includes project history.",
  operation: "Operation",
  destination: "Destination project",
  status: "Status",
  fileCount: "Files",
  totalBytes: "Total bytes",
  recordCount: "Records",
  warnings: "Warnings",
  paused: "I confirm that source edits and uploads are paused.",
  apply: "Copy project",
  retry: "Retry copy",
  cleanup: "Clean up unpublished copy",
  cleanupConfirm: "Remove the unpublished files for this operation? To copy again after cleanup, create a new preview.",
  confirmCleanup: "Confirm cleanup",
  cancel: "Cancel",
  refresh: "Refresh status",
  working: "The request is running. Keep source edits and uploads paused.",
  unknown: "The outcome is unknown. Check status before trying again. No copy request will be repeated automatically.",
  checking: "Checking operation status…",
  open: "Open destination project",
  access: "Opening the project requires access to the destination account.",
  ready: "Ready",
  copy: "Copying",
  failed: "Copy failed",
  complete: "Complete",
  cleanupStatus: "Cleaning up",
  cleanupFailed: "Cleanup failed",
  cleaned: "Cleaned up",
};
